/* global axios */
import ApiClient from './ApiClient';

class KanbanSettingsAPI extends ApiClient {
  constructor() {
    super('kanban_settings', { accountScoped: true });
  }

  update(data) {
    return axios.patch(this.url, { kanban: data });
  }
}

export default new KanbanSettingsAPI();
